import React, { useContext, useState, useEffect } from "react"
import { Container, Row, Col } from "react-grid-system"
import { AiOutlineCopy } from "react-icons/ai"

import { AppContext } from "../context/GlobalContext"

import { colorArrayToHex, getBrightness } from "../helpers/functions"
import Popup from "./Popup"

const ColorsContainer = () => {
  let { globalState } = useContext(AppContext)
  let { colors } = globalState

  let [colorsArray, setColorsArray] = useState([])
  let [currentColor, setCurrentColor] = useState(null)
  let [visible, setVisible] = useState(false)

  useEffect(() => {
    setColorsArray(colors)
  }, [colors])

  const copyTextToClipboard = (color) => {
    setCurrentColor(color)
    setVisible(true)
  }

  return (
    <div className="colors">
      <h3 className="colors__title">
        Explore <span className="colors__title-circle">colors</span> gotten from
        the Image
      </h3>
      {colorsArray.length === 0 ? (
        <p className="colors__desc">
          Imagine there several images online or locally that you
          need their colors from to build or design beautiful apps, well no need
          to look further, why don't you upload your image above and be wowed by
          our services.
        </p>
      ) : null}

      {colorsArray.length === 0 ? (
        <img
          src={require("../assets/images/upload.png")}
          alt=""
          className="colors__img"
        />
      ) : null}
      <Container>
        <Row>
          {colorsArray.map((color) => {
            let hex = colorArrayToHex(color),
              brightness = getBrightness(color)
            return (
              <Col md={4} sm={6} className="colors__col">
                <div
                  className="colors__color-box"
                  style={{ boxShadow: `0 0 10px ${hex}4D` }}
                  onClick={() => copyTextToClipboard(color)}
                >
                  <div
                    className="colors__color-box--color"
                    style={{
                      backgroundColor: hex,
                    }}
                  >
                    <h4
                      className="colors__color-box--color-text"
                      style={{ color: brightness < 90 ? "white" : "white" }}
                    >
                      {hex}
                    </h4>
                  </div>
                  <div className="colors__color-box--copy">
                    <AiOutlineCopy />
                  </div>
                </div>
              </Col>
            )
          })}
        </Row>
      </Container>

      <Popup color={currentColor} setVisible={setVisible} visible={visible} />
    </div>
  )
}

export default ColorsContainer
